import React from "react";
import "./TopNavigation.css";
import logo from "../../../assets/images/logo.svg";

export function TopNavigation() {
  return (
    <div className="navigation">
      <img src={logo} alt="logo" style={{ width: "33rem" }} />
    </div>
  );
}
